import config from '../../config';

const getIsDevelopmentEnv = () => config.get('NODE_ENV') === 'development';

export default getIsDevelopmentEnv;
